import { render, staticRenderFns } from "./PatentManagementInfo.vue?vue&type=template&id=18944b9c&scoped=true"
import script from "./PatentManagementInfo.vue?vue&type=script&lang=js"
export * from "./PatentManagementInfo.vue?vue&type=script&lang=js"
import style0 from "./PatentManagementInfo.vue?vue&type=style&index=0&id=18944b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18944b9c",
  null
  
)

export default component.exports